(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var charts = document.querySelectorAll('.chart-line-decline');
  if (!charts.length) return;

  charts.forEach(function (chart) {
    var line = chart.querySelector('[data-chart-line]');
    var fill = chart.querySelector('[data-chart-fill]');
    var counter = chart.querySelector('[data-chart-counter]');

    if (line) {
      try {
        var len = line.getTotalLength();
        line.style.strokeDasharray = len;
        line.style.strokeDashoffset = len;
      } catch (e) { /* leave at end state */ }
    }

    if (fill) {
      fill.style.opacity = '0';
    }

    if (counter) {
      counter.textContent = counter.dataset.chartStart + '%';
    }
  });

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var chart = entry.target;
      if (chart.dataset.chartPlayed) return;
      chart.dataset.chartPlayed = '1';

      var line = chart.querySelector('[data-chart-line]');
      var fill = chart.querySelector('[data-chart-fill]');
      var counter = chart.querySelector('[data-chart-counter]');
      var duration = parseInt(chart.dataset.chartDuration, 10) || 2000;
      var delay = parseInt(chart.dataset.chartDelay, 10) || 0;

      var startVal = counter ? parseInt(counter.dataset.chartStart, 10) || 0 : 0;
      var endVal = counter ? parseInt(counter.dataset.chartEnd, 10) || 0 : 0;

      var totalLength = 0;
      if (line) {
        try { totalLength = line.getTotalLength(); } catch (e) { /* noop */ }
      }

      function startAnimation() {
        var animStart = performance.now();

        function tick(now) {
          var t = Math.min(1, (now - animStart) / duration);
          var eased = 1 - Math.pow(1 - t, 3);

          if (line && totalLength) {
            line.style.strokeDashoffset = totalLength * (1 - eased);
          }

          if (fill) {
            fill.style.opacity = eased;
          }

          if (counter) {
            counter.textContent = Math.round(startVal + (endVal - startVal) * eased) + '%';
          }

          if (t < 1) {
            requestAnimationFrame(tick);
          } else {
            if (line) line.style.strokeDashoffset = '0';
            if (fill) fill.style.opacity = '1';
            if (counter) counter.textContent = endVal + '%';
          }
        }

        requestAnimationFrame(tick);
      }

      if (delay > 0) {
        setTimeout(startAnimation, delay);
      } else {
        startAnimation();
      }
      obs.unobserve(chart);
    });
  }, { threshold: 0.15 });

  charts.forEach(function (el) { obs.observe(el); });
})();
